import styled, { keyframes } from 'styled-components';
import * as variables from 'styles/variables';

export const rotateAnimation = keyframes`
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
`;

export const LoaderInline = styled.div`
    margin: 2px;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 2px solid ${variables.primaryColors.secondary};
    border-bottom: 2px solid ${variables.primaryColors.primary};
    animation: ${rotateAnimation} 1.5s linear infinite;
`;